﻿import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { AtlGridNestedTwoColsProps, AtlGridTagNames } from './grid.props';
import { getGlobalStyleSheets } from '../../global-styles';

@customElement(AtlGridTagNames.NestedTwoCols)
export class AtlGridNestedTwoCols
   extends LitElement
   implements AtlGridNestedTwoColsProps
{
   declare firstColClassName?: string;
   declare secondColClassName?: string;
   declare fullHeight: boolean;

   static properties = {
      firstColClassName: { type: String, attribute: 'first-col-class-name' },
      secondColClassName: { type: String, attribute: 'second-col-class-name' },
      fullHeight: { type: Boolean, attribute: 'full-height' },
   };

   static styles = [
      ...getGlobalStyleSheets(),
      css`
         :host {
            display: block;
         }
      `,
   ];

   render() {
      const classNameBuilder = ['row', 'grid-nested-two-col'];
      if (this.fullHeight) {
         classNameBuilder.push('h-100');
      }

      const firstColClassNameBuilder = ['col-md-6'];
      if (this.firstColClassName) {
         firstColClassNameBuilder.push(this.firstColClassName);
      }

      const secondColClassNameBuilder = ['col-md-6'];
      if (this.secondColClassName) {
         secondColClassNameBuilder.push(this.secondColClassName);
      }

      return html`
         <div class=${classNameBuilder.join(' ')}>
            <div class=${firstColClassNameBuilder.join(' ')}>
               <slot name="first-col"></slot>
            </div>
            <div class=${secondColClassNameBuilder.join(' ')}>
               <slot name="second-col"></slot>
            </div>
         </div>
      `;
   }
}
